const is_front_page =
  typeof sendToJs !== 'undefined' && typeof sendToJs.is_front_page !== 'undefined'
    ? sendToJs.is_front_page
    : false;

const nav = () => {
    const toggle = document.querySelector('.menu-toggle');
    const navbar = document.querySelector('.primary-site-navigation');
    if( !toggle || !navbar ) return;

    toggle.addEventListener('click', function () {
        navbar.classList.toggle('open');
        toggle.classList.toggle('active');
    });
}

const header = () => {
  const header = document.querySelector(".site-header");
  if (!header) return;
  header.classList.remove("is-hidden");

  const title = document.querySelector(".hero-animation__title");
  const heroTitle = document.querySelector(".hero-animation--title");
  const scrollSequenceBlock = document.querySelector('.wp-block-ideeundliebe-scrollsequence');

  const updateScrollSequenceHeaderState = () => {
    if (!header.classList.contains('-no') || !scrollSequenceBlock) {
      header.classList.remove('has-solid-background');
      return;
    }

    const headerHeight = header.offsetHeight || 0;
    const isPastScrollSequence = scrollSequenceBlock.getBoundingClientRect().bottom <= headerHeight;

    header.classList.toggle('has-solid-background', isPastScrollSequence);
  };

  let lastScroll = window.pageYOffset;
  let scrollStartUp = null;

  updateScrollSequenceHeaderState();

  window.addEventListener("scroll", () => {

    const currentScroll = window.pageYOffset;
    let plus = 250;

    if(1 === parseInt(is_front_page)) {
      plus = 0;
    }

    if (currentScroll > lastScroll && currentScroll > plus) {
      // scrolling down
      header.classList.add("is-hidden");
      scrollStartUp = null;

      if (title) {
        title.style.opacity = Math.max(0, 1 - currentScroll / 300);
      }

      if( heroTitle ) {
        heroTitle.style.opacity = Math.max(0, 1 - currentScroll / 300);
      }

    } else if (currentScroll < lastScroll) {
      // scrolling up

      if (scrollStartUp === null) {
        scrollStartUp = currentScroll;
      }

      if (scrollStartUp - currentScroll > 500) {
        header.classList.remove("is-hidden");
      }

      if (title) {
        title.style.opacity = Math.max(0, 1 - currentScroll / 300);
      }

      if( heroTitle ) {
        heroTitle.style.opacity = Math.max(0, 1 - currentScroll / 300);
      }
    }

    lastScroll = currentScroll;
    updateScrollSequenceHeaderState();

    // always show near the top
    if (currentScroll < 250) {
      header.classList.remove("is-hidden");
    }

  });

  window.addEventListener('resize', updateScrollSequenceHeaderState);
};

document.addEventListener("DOMContentLoaded", function() {
    nav();
    header();
});

function updateMainPadding() {
    const header = document.querySelector('.site-header');
    const page = document.querySelector('.il-page');

    console.log(header)
    console.log(page)

    if (header && page) {
        page.style.paddingTop = `${header.offsetHeight}px`;
    }
}

// window.addEventListener('resize', updateMainPadding);
// window.addEventListener('load', updateMainPadding); // initial set